module.exports = __webpack_public_path__ + "img/00-plan-b.2e6104f3.png";